module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap"
  }, [_c('div', {
    staticClass: "header-wrap-sticky",
    attrs: {
      "id": "pageNotStickyHeader"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.header_data
    }
  })], 1), _vm._v(" "), (_vm.menu_tab_view.viewTransfer) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.transfer_ref == '') ? _c('a', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "16px",
      "color": "#000000"
    }
  }), _vm._v(" BACK\r\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('h2', {
    staticStyle: {
      "float": "left",
      "margin-top": "-0.01em"
    }
  }, [_vm._v("Agent Services")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right",
      "color": "#000000",
      "font-weight": "bold"
    }
  }, [_c('b', [_vm._v("REF NO: ")]), _c('br'), _vm._v(_vm._s(_vm.transfer.payment_order_ref))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.transfer.payment_order_to))]), _vm._v(" "), _c('p', [(_vm.transfer.payment_order_business_email != '') ? _c('span', [_vm._v(_vm._s(_vm.transfer.payment_order_business_email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.transfer.payment_order_business_phone != '') ? _c('span', [_vm._v(_vm._s(_vm.transfer.payment_order_business_phone))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_user_name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_user_email))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_user_phone))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin-top": "0.2em"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.transfer.payment_order_set_date))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-row"
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('h5', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Order Items")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "border": "#000000 solid 1px",
      "width": "100% !important"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.transfer.payment_order_items), function(item, index) {
    return _c('tr', {}, [_c('td', [_vm._v(_vm._s(++index))]), _vm._v(" "), _c('td', [_c('p', [_vm._v(_vm._s(item.product_name) + "\r\n                "), _vm._v(" "), _c('a', {
      staticClass: "card-link",
      staticStyle: {
        "float": "right",
        "color": "#f32144",
        "font-size": "12px"
      },
      on: {
        "click": function($event) {
          _vm.transfer_item = item;
          _vm.set_view = true;
        }
      }
    }, [_vm._v("View")])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.order_item_quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency_2(item.order_item_total)))])])
  })], 2), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "col-xs-8",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('p', [_c('b', [_vm._v("Total: ")]), _vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.transfer.payment_order_order_details.order_total)))]), _vm._v(" "), _c('p', [_c('b', [_vm._v("Status: ")]), _vm._v(_vm._s(_vm.transfer.payment_order_order_details.order_payment_status))])])]), _vm._v(" "), _vm._m(1)])])]) : _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "4em"
    }
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin": "1em"
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("Generate and make Transfer payments for goods and services")]), _vm._v(" "), _c('a', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#f32144",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.setGenerateReceipt()
      }
    }
  }, [_vm._v("\r\n        Generate Transfer Receipt\r\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "card-link btn sp-button-02 sp-button-02-lt",
    staticStyle: {
      "float": "right",
      "font-size": "13px",
      "margin-top": "0.1em",
      "text-transform": "inherit",
      "background-color": "#f32144",
      "color": "#ffffff",
      "border-radius": "5px",
      "padding": "3px 10px"
    },
    on: {
      "click": function($event) {
        _vm.makeTransFerOrder()
      }
    }
  }, [_vm._v("\r\n          Make Payment;\r\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('hr'), _vm._v(" "), _vm._l((_vm.transfers), function(transfer, index) {
    return _c('div', {
      staticClass: "card card-row",
      staticStyle: {
        "background": "#ffffff",
        "border-radius": "0px",
        "margin-bottom": "0.6em"
      }
    }, [_c('div', {
      staticStyle: {
        "width": "99%",
        "padding-top": "0.1em"
      }
    }, [_c('div', {
      staticClass: "col-xs-12 colx"
    }, [_c('div', {
      staticClass: "col-xs-9 colx"
    }, [_c('p', [(transfer.payment_order_is_from == 1) ? _c('span', [_vm._m(3, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(transfer.payment_order_from))])]) : _vm._e(), _vm._v(" "), (transfer.payment_order_is_to == 1) ? _c('span', [_vm._m(4, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(transfer.payment_order_to))])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(transfer.payment_order_total_amount)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(transfer.payment_order_set_date_f))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3 colx"
    }, [_c('a', {
      staticClass: "card-link btn sp-button-02 sp-button-02-lt",
      staticStyle: {
        "float": "right",
        "font-size": "13px",
        "margin-top": "0.1em",
        "text-transform": "inherit",
        "background-color": "#21a6f3",
        "color": "#ffffff",
        "border-radius": "5px",
        "padding": "3px 10px"
      },
      on: {
        "click": function($event) {
          _vm.setMenuTabView('viewTransfer', transfer)
        }
      }
    }, [_vm._v("\r\n                    View\r\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    }), _vm._v(" "), _c('hr')])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })], 2)])]), _vm._v(" "), _c('component-footer'), _vm._v(" "), (_vm.set_view) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "display": "block",
      "z-index": "10000"
    },
    attrs: {
      "id": "viewBox"
    }
  }, [_c('a', {
    staticClass: "card-link",
    on: {
      "click": function($event) {
        _vm.set_view = false
      }
    }
  }, [_c('span', {
    staticClass: "s-backdrop"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "width": "100%",
      "bottom": "0",
      "margin": "0 -1.2em",
      "background": "none",
      "z-index": "10000"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "0.1em",
      "background": "#ffffff",
      "color": "#000000",
      "border-top": "#061433 solid",
      "border-radius": "45px 45px 0px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "80vh"
    }
  }, [_c('div', [_c('a', {
    staticStyle: {
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.set_view = false
      }
    }
  }, [_vm._m(5), _vm._v(" "), _c('span', {
    staticClass: "card-link",
    staticStyle: {
      "float": "right",
      "padding": "1em",
      "font-size": "28px"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 5em",
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.img_product_url + _vm.transfer_item.product_item_group_image
    }
  })]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.transfer_item.product_name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("₦" + _vm._s(_vm.formatCurrency_2(_vm.transfer_item.product_item_total_price)))])])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("S/N")]), _vm._v(" "), _c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Qty")]), _vm._v(" "), _c('th', [_vm._v("Amount(₦)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "margin": "0",
      "padding": "0",
      "text-align": "center"
    }
  }, [_c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-02-lt",
    staticStyle: {
      "background": "#f32144",
      "color": "#ffffff"
    }
  }, [_vm._v("Make Payment")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "htro"
  }, [_c('span', [_vm._v(" ")]), _vm._v("Agent Services")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("From: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('b', [_vm._v("To: ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "-1em",
      "margin-bottom": "-0.3em",
      "padding": "0",
      "font-size": "2em"
    }
  }, [_c('span', [_vm._v("___")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70882e3e"}!./src/pages/AgentServices/template.html
// module id = 562
// module chunks = 0